import { render, staticRenderFns } from "./reel.vue?vue&type=template&id=5a936320&scoped=true&"
import script from "./reel.vue?vue&type=script&lang=js&"
export * from "./reel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a936320",
  null
  
)

export default component.exports